/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FullSupporter } from './FullSupporter';
import {
    FullSupporterFromJSON,
    FullSupporterFromJSONTyped,
    FullSupporterToJSON,
} from './FullSupporter';
import type { VersionMetadata } from './VersionMetadata';
import {
    VersionMetadataFromJSON,
    VersionMetadataFromJSONTyped,
    VersionMetadataToJSON,
} from './VersionMetadata';

/**
 * 
 * @export
 * @interface FullGetSupporter
 */
export interface FullGetSupporter {
    /**
     * 
     * @type {number}
     * @memberof FullGetSupporter
     */
    latestChainBlock: number;
    /**
     * 
     * @type {number}
     * @memberof FullGetSupporter
     */
    latestIndexedBlock: number;
    /**
     * 
     * @type {number}
     * @memberof FullGetSupporter
     */
    latestChainSlotPlays: number;
    /**
     * 
     * @type {number}
     * @memberof FullGetSupporter
     */
    latestIndexedSlotPlays: number;
    /**
     * 
     * @type {string}
     * @memberof FullGetSupporter
     */
    signature: string;
    /**
     * 
     * @type {string}
     * @memberof FullGetSupporter
     */
    timestamp: string;
    /**
     * 
     * @type {VersionMetadata}
     * @memberof FullGetSupporter
     */
    version: VersionMetadata;
    /**
     * 
     * @type {FullSupporter}
     * @memberof FullGetSupporter
     */
    data?: FullSupporter;
}

/**
 * Check if a given object implements the FullGetSupporter interface.
 */
export function instanceOfFullGetSupporter(value: object): value is FullGetSupporter {
    let isInstance = true;
    isInstance = isInstance && "latestChainBlock" in value && value["latestChainBlock"] !== undefined;
    isInstance = isInstance && "latestIndexedBlock" in value && value["latestIndexedBlock"] !== undefined;
    isInstance = isInstance && "latestChainSlotPlays" in value && value["latestChainSlotPlays"] !== undefined;
    isInstance = isInstance && "latestIndexedSlotPlays" in value && value["latestIndexedSlotPlays"] !== undefined;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "version" in value && value["version"] !== undefined;

    return isInstance;
}

export function FullGetSupporterFromJSON(json: any): FullGetSupporter {
    return FullGetSupporterFromJSONTyped(json, false);
}

export function FullGetSupporterFromJSONTyped(json: any, ignoreDiscriminator: boolean): FullGetSupporter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'latestChainBlock': json['latest_chain_block'],
        'latestIndexedBlock': json['latest_indexed_block'],
        'latestChainSlotPlays': json['latest_chain_slot_plays'],
        'latestIndexedSlotPlays': json['latest_indexed_slot_plays'],
        'signature': json['signature'],
        'timestamp': json['timestamp'],
        'version': VersionMetadataFromJSON(json['version']),
        'data': !exists(json, 'data') ? undefined : FullSupporterFromJSON(json['data']),
    };
}

export function FullGetSupporterToJSON(value?: FullGetSupporter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'latest_chain_block': value.latestChainBlock,
        'latest_indexed_block': value.latestIndexedBlock,
        'latest_chain_slot_plays': value.latestChainSlotPlays,
        'latest_indexed_slot_plays': value.latestIndexedSlotPlays,
        'signature': value.signature,
        'timestamp': value.timestamp,
        'version': VersionMetadataToJSON(value.version),
        'data': FullSupporterToJSON(value.data),
    };
}

